import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Stage } from '@src/app/models/stage';
import { Task } from '@src/app/models/task';
import { Projectmember } from '@src/app/models/projectmember';
import { ProjectstageService } from './service/projectstage.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Projectcomment } from '../projecttask/model/comment';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import "quill-mention/autoregister";
import { QuillEditorComponent } from 'ngx-quill';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { FormService } from '@src/app/components/forms/service/form.service';
import { FormTemplate } from '@src/app/components/forms/models/form.model';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalService } from '@src/app/helpers/modal.service';
import { TimeregistrationService } from '@src/app/helpers/timeregistration/timeregistration.service';
import { formatMinutesAsHours } from '@src/app/helpers/timeregistration/hours.util';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectstage',
  templateUrl: './projectstage.component.html',
  styleUrls: ['./projectstage.component.css'],
  animations: [
    trigger(
      'inbgOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ opacity: 0 }),
            animate('0.5s ease-out',
              style({ opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ opacity: 1 }),
            animate('0.5s ease-in',
              style({ opacity: 0 }))
          ]
        )
      ]
    )
  ]

})
export class ProjectstageComponent implements OnInit, OnChanges {
  @Input() stage: Stage;
  @Input() stagecount: number;
  @Input() taskList: Task[] = [];
  @Input() projectMembers: Projectmember[] = [];
  @Input() projectCustomerMembers: Projectmember[] = [];
  @Input() stageindex: number;
  @Input() projectCustomerId: string;
  @Input() @Output() commentsList: Projectcomment[] = [];
  @Input() @Output() listview: boolean;
  @Output() stageToDelete = new EventEmitter<Stage>();
  collapsedstage: boolean;
  modalTask: Task;
  stageTaskList: Task[] = [];
  isCustomer: boolean;
  timeregEnabled: boolean;
  newTaskEstimateHours: number;
  stageTimeSummaryLoaded: boolean = false;
  stageEstimateMinutes: number;
  stageLoggedMinutes: number;
  formIsValid: boolean;
  errorMessage: string;
  @Output() stageoptionToggler: boolean = false;
  @Output() stageinfoToggler: boolean = false;
  formIsValidEditStage: boolean;
  taskcreatedstate: boolean;
  @ViewChild(QuillEditorComponent, { static: true }) editor: QuillEditorComponent;
  @ViewChild('closeeditmodal', { static: true }) closeeditmodal: ElementRef;
  @ViewChild('deletemodalclose', { static: true }) deletemodalclose: ElementRef;
  deletestage: boolean;
  showSpinner: boolean;
  uploadcounter: number;
  acceptwarning: boolean;
  showsuccestaskcreate: boolean;
  publishedForms: FormTemplate[] = [];
  loadingForms: boolean = false;
  hasPublishedForms: boolean = false;
  formTouched: boolean = false;
  showeditstage: boolean = false;
  formats = [
    'background',
    'bold',
    'color',
    'font',
    'code',
    'italic',
    'link',
    'size',
    'strike',
    'script',
    'underline',
    'blockquote',
    'header',
    'indent',
    'list',
    'align',
    'direction',
    'code-block',
    'formula'
    // 'image'
    // 'video'
  ];
  modules = {
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      // onSelect: (item, insertItem) => {
      //   const editor = this.editor.quillEditor
      //   insertItem(item)
      //   // necessary because quill-mention triggers changes as 'api' instead of 'user'
      //   editor.insertText(editor.getLength() - 1, '', 'user')
      // },
      source: (searchTerm, renderList) => {
        const members = this.projectMembers.concat(this.projectCustomerMembers)
        const values = [];
        for (let index = 0; index < members.length; index++) {
          values.push({ id: members[index].personId, value: members[index].fullname });
        }

        if (searchTerm.length === 0) {
          renderList(values, searchTerm)
        } else {
          const matches = []

          values.forEach((entry) => {
            if (entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) {
              matches.push(entry)
            }
          })
          renderList(matches, searchTerm)
        }
      }
    },
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link']
    ],
  };

  constructor(private pssrv: ProjectstageService,
    private auth: AuthorizationService,
    private uieventhub: UieventhubService,
    private datastore: DatastoreService,
    private modalService: ModalService,
    private formService: FormService,
    private timeregSrv: TimeregistrationService
  ) { }


  ngOnInit() {
    this.taskList = [];
    this.collapsedstage = true;
    this.taskcreatedstate = false;
    this.acceptwarning = false;
    this.deletestage = false;
    this.showSpinner = false;
    this.modalTask = new Task;
    this.setNewTask();
    this.loadPublishedForms();
    if (SessionHelper.getCustomer()) {
      this.isCustomer = true;
    } else {
      this.isCustomer = false;
    }
    this.timeregEnabled = SessionHelper.hasModule('timereg') && !this.isCustomer;
    this.loadStageTimeSummary();
    this.datastore.taskList$.pipe(untilDestroyed(this)).subscribe((tlist) => {
      console.log('[ProjectStage] Received task list update from datastore:', tlist);
      this.taskList = tlist || [];
      this.refreshStageTaskList(this.taskList);
    });
    this.validate();
    //this.getCustomerUsers();
  }

  //   getCustomerUsers(){
  //     this.projectCustomerMembers = [];
  //     if(this.projectCustomerId){
  //     this.datastore.customersUsers.getValue().filter(cu => cu.customerId.split('_')[0] == this.projectCustomerId).forEach(cu => {
  //       this.projectCustomerMembers.push({
  //         userId: cu.userId,
  //         projectId: this.stage.projectId,
  //         personId: cu.userId.split('_')[0],
  //         fullname: cu.fullname,
  //         email: cu.email,
  //         phone: cu.phone,
  //         im: "",
  //         iscustomer: true
  //       });
  //     });
  //   }
  // }
  ngOnChanges(changes: SimpleChanges) {


    if (changes.taskList) {
      this.taskList = changes.taskList.currentValue || [];
      this.refreshStageTaskList(this.taskList);
    }
    if (changes.commentsList && changes.commentsList.currentValue) {
      this.commentsList = changes.commentsList.currentValue;
    }
    if (changes.projectCustomerId && changes.projectCustomerId.currentValue) {
      //this.getCustomerUsers();
    }
    if (changes.projectMembers && changes.projectMembers.currentValue) {
      this.projectMembers = changes.projectMembers.currentValue;
    }
    if (changes.projectCustomerMembers && changes.projectCustomerMembers.currentValue) {
      this.projectCustomerMembers = changes.projectCustomerMembers.currentValue;
    }


  }

  private refreshStageTaskList(tasks: Task[]): void {
    if (!this.stage || !this.stage.stageId) {
      this.stageTaskList = [];
      return;
    }

    const stageIdBase = this.stage.stageId.split('_')[0];
    this.stageTaskList = (tasks || []).filter(task => task.stageId.split('_')[0] == stageIdBase);
    if (SessionHelper.getViewAsCustomer() == 'true') {
      this.stageTaskList = this.stageTaskList.filter(task => task.taskvisibility == "shared");
    }
    this.stageTaskList.sort((a, b) => a.sortOrder - b.sortOrder);
    this.validateEditStage();
  }

  closeTaskModal() {
    this.modalTask = new Task;
    this.modalService.close('taskmodal' + this.stageindex);
  }

  drop(event: CdkDragDrop<any[]>) {
    //console.log('dropped',event);
    this.showSpinner = true;


    if (event.container.id === event.previousContainer.id) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    var eventLists = {
      "container": event.container.data,
      "previousContainer": event.previousContainer.data,
      "stage": this.stage,
      "taskDropped": event.container.data[event.currentIndex],
    }

    //update tasklist
    this.stageTaskList = event.container.data;
    let taskindex = this.stageTaskList.indexOf(eventLists.taskDropped);
    this.stageTaskList[taskindex].sortOrder = event.currentIndex;
    this.stageTaskList[taskindex].stageId = eventLists.stage.stageId;
    this.stageTaskList[taskindex].stagename = eventLists.stage.title;
    //this.stageTaskList[taskindex].organizationId = eventLists.stage.organizationId;
    if (this.stageTaskList[taskindex].taskstate != "Done" && event.container.id !== event.previousContainer.id) {
      this.stageTaskList[taskindex].startdate = eventLists.stage.startdate;
      this.stageTaskList[taskindex].duedate = eventLists.stage.enddate;

    }
    this.datastore.postponeLoad();
    this.pssrv.taskOrder(eventLists).pipe(untilDestroyed(this)).subscribe(result => {
      this.showSpinner = false;
      //this.pssrv.generateStats(this.stage.projectId ).pipe(untilDestroyed(this)).subscribe(result => {});

    });
  }
  canEditStage() {
    return this.auth.isAuthorized("stageedit", this.stage.stageId);
  }

  get stageDescriptionLength(): number {
    return (this.stage && this.stage.description ? this.stage.description : '').length;
  }

  edit() {
    this.stageToDelete.emit(this.stage);
  }
  addTask() {
    if (!this.modalTask.title || !this.modalTask.duedate || !this.modalTask.startdate || this.formIsValid == false || !this.modalTask.responsible) {
      this.errorMessage = 'modalvalidation.requiredfieldmissing';
    } else {
      this.errorMessage = null;
      this.showSpinner = true;
      if (!this.modalTask.description) {
        this.modalTask.description = " ";
      }
      //quill br temp fix
      this.modalTask.description = this.modalTask.description.replace(new RegExp("<p></p>", 'g'), "<br>");
      //quill br temp fix end
      this.modalTask.stageId = this.stage.stageId;
      this.modalTask.stagename = this.stage.title;
      this.modalTask.taskstate = "waiting";
      this.modalTask.projectId = SessionHelper.getCurrentProject();
      this.modalTask.validto = new Date('9999-01-01').toISOString();
      this.modalTask.creator = SessionHelper.getUserSub();
      this.modalTask.created = new Date().toISOString();

      this.modalTask.organizationname = this.stage.organizationname;
      this.modalTask.organizationId = this.stage.organizationId;
      this.modalTask.orgdesc = this.stage.orgdesc;
      this.modalTask.orgemail = this.stage.orgemail;
      this.modalTask.orglogourl = this.stage.orglogourl;
      this.modalTask.orgwww = this.stage.orgwww;
      this.modalTask.customer = this.stage.customer;
      this.modalTask.customername = this.stage.customername;
      this.modalTask.sortOrder = this.stageTaskList.length + 1;
      this.normalizeFormTemplatePayload(this.modalTask);
      //console.log(this.modalTask)
      this.pssrv.addTask(this.modalTask).pipe(untilDestroyed(this)).subscribe(taskId => {
        this.modalTask.taskId = taskId;
        const createdTask: Task = { ...this.modalTask };
        this.pushCreatedTaskToDatastore(createdTask);

        // Initial estimate (timereg org module): posted as a separate call
        // right after creation, since a task needs to exist before it can
        // carry an estimate history.
        if (this.timeregEnabled && this.newTaskEstimateHours > 0) {
          const initialEstimateMinutes = Math.round(this.newTaskEstimateHours * 60);
          this.timeregSrv.addTaskEstimate(createdTask.projectId, taskId, initialEstimateMinutes)
            .pipe(untilDestroyed(this))
            .subscribe({
              error: (err) => console.error('[ProjectStage] Failed to set initial estimate', err),
            });
        }

        // Create form link if task type is 'form' and form template is selected
        if (this.modalTask.tasktype === 'form' && this.modalTask.formTemplateId) {
          this.createFormLink(taskId);
        }

        this.modalTask = new Task;
        this.acceptwarning = false;
        this.setNewTask();
        this.showSpinner = false;
        this.taskcreatedstate = true;
        this.closeTaskModal();
        this.showsuccestaskcreateFunc();
        //this.auth.refreshPersonAuth(SessionHelper.getUserSub());
        //this.pssrv.generateStats(this.modalTask.projectId ).pipe(untilDestroyed(this)).subscribe(result => {});
        //this.stageTaskList.push(this.modalTask);
        //this.uieventhub.setAddTask(this.modalTask);
        //this.datastore.addTask(this.modalTask);

      });
    }
  }

  private normalizeFormTemplatePayload(task: Task): void {
    if (task.tasktype !== 'form') {
      task.formTemplateId = undefined;
      task.formTemplateVersion = undefined;
      task.formTemplateName = undefined;
      return;
    }

    if (!task.formTemplateId) {
      return;
    }

    if (task.formTemplateId.includes('_v')) {
      const [baseId, versionPart] = task.formTemplateId.split('_v');
      const parsedVersion = parseInt(versionPart, 10);

      task.formTemplateId = baseId;
      if (!Number.isNaN(parsedVersion)) {
        task.formTemplateVersion = parsedVersion;
      }
    }

    if (task.formTemplateVersion != null) {
      task.formTemplateVersion = Number(task.formTemplateVersion);
    }
  }

  private pushCreatedTaskToDatastore(createdTask: Task): void {
    const currentTasks = this.datastore.taskList.getValue() || [];
    const createdTaskBaseId = (createdTask.taskId || '').split('_')[0];
    const exists = currentTasks.some(t => (t.taskId || '').split('_')[0] === createdTaskBaseId);
    if (exists) {
      return;
    }

    const nextTasks = [...currentTasks, createdTask].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
    this.datastore.taskList.next(nextTasks);
  }
  validate() {
    // Additional validation for form tasks - must have a form template selected
    if (this.modalTask.tasktype === 'form' && !this.modalTask.formTemplateId) {
      this.formTouched = true;
      this.formIsValid = false;
      return;
    }

    if (
      this.modalTask.duedate &&
      this.modalTask.startdate &&
      this.modalTask.title &&
      this.modalTask.responsible
    ) {
      if (this.willLoseAccess()) {
        if (this.acceptwarning) {
          this.formIsValid = true;
        } else {
          this.formIsValid = false;
        }
      } else {
        this.formIsValid = true;
      }

    } else {
      this.formIsValid = false;
    }
    //console.log('formIsValid',this.formIsValid);
  }
  willLoseAccess() {
    if (this.auth.isAuthorized("orgedit", SessionHelper.getChoosenOrg())) {
      return false;
    } else {
      if (this.modalTask.responsible && this.modalTask.responsible != SessionHelper.getUserSub()) {
        return true;
      } else {
        return false;
      }
    }

  }
  setNewTask() {
    this.modalTask.stageId = this.stage.stageId;
    const fallbackDate = new Date().toISOString().substring(0, 10);
    this.modalTask.duedate = this.stage?.enddate ? String(this.stage.enddate).substr(0, 10) : fallbackDate;
    this.modalTask.startdate = this.stage?.startdate ? String(this.stage.startdate).substr(0, 10) : fallbackDate;
    this.modalTask.taskvisibility = 'shared';
    this.modalTask.responsible = 'choose';
    this.modalTask.uploadFields = [''];
    this.newTaskEstimateHours = undefined;
    this.taskcreatedstate = false;
  }

  loadStageTimeSummary() {
    if (!this.timeregEnabled || !this.stage?.projectId || !this.stage?.stageId) {
      return;
    }
    this.timeregSrv.getProjectTimeSummaryCached(this.stage.projectId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (summary) => {
          const stageSummary = summary.stages.find((s) => s.stageId === this.stage.stageId);
          this.stageEstimateMinutes = stageSummary ? stageSummary.estimateMinutes : 0;
          this.stageLoggedMinutes = stageSummary ? stageSummary.loggedMinutes : 0;
          this.stageTimeSummaryLoaded = true;
        },
        error: (err) => console.error('[ProjectStage] Failed to load stage time summary', err),
      });
  }

  // "1/2,5" — logged over estimated for this stage, only once there's
  // something to show (a stage with no estimated tasks stays quiet).
  stageTimeCounterLabel(): string | null {
    if (!this.stageTimeSummaryLoaded || !this.stageEstimateMinutes) {
      return null;
    }
    return formatMinutesAsHours(this.stageLoggedMinutes, ',') + '/' + formatMinutesAsHours(this.stageEstimateMinutes, ',');
  }

  stageTimeCounterTooltip(): string {
    return formatMinutesAsHours(this.stageLoggedMinutes, ',') + ' h logged / '
      + formatMinutesAsHours(this.stageEstimateMinutes, ',') + ' h estimated';
  }

  editStage() {
    if (!this.stage.title || !this.stage.enddate || !this.stage.startdate) {
      this.errorMessage = "modalvalidation.requiredfieldmissing";
    } else {
      this.showSpinner = true;
      if (!this.stage.description) {
        this.stage.description = " ";
      }
      //console.log(this.stage);
      this.pssrv.editStage(this.stage).pipe(untilDestroyed(this)).subscribe(result => {
        this.closeeditmodal.nativeElement.click();
        this.showSpinner = false;
      });
    }
  }
  deleteStage() {
    this.pssrv.deleteStage(this.stage).pipe(untilDestroyed(this)).subscribe(result => {
      if (result != 'Tasks exits in stage, cannot delete') {
        this.stageToDelete.emit(this.stage);
        this.deletemodalclose.nativeElement.click();

      }

    });
  }
  deleteConfirm() {
    this.deletestage = !this.deletestage;
  }
  validateEditStage() {
    if (
      this.stage.enddate &&
      this.stage.startdate &&
      this.stage.title &&
      this.stage.description) {
      this.formIsValidEditStage = true;
    } else {
      this.formIsValidEditStage = false;
    }
  }
  ngAfterViewInit() {

    this.uieventhub.removeLoader('projectportal_stages');
    // if no tasks remove loaders for task and portal
    if (!this.stageTaskList || this.stageTaskList.length == 0) {
      this.uieventhub.clearLoaders();

    }

  }

  stageoptionToggle() {
    this.stageoptionToggler = !this.stageoptionToggler;
  };

  stageinfoToggle() {
    this.stageinfoToggler = !this.stageinfoToggler;
  };

  trackByTaskId = (_: number, task: Task) => task?.taskId || _;

  trackByIndex = (_: number, __: unknown) => _;

  fileInputs: string[] = [''];
  addFileInput(): void {
    this.fileInputs.push('');
    this.modalTask.uploadFields.push('');
  }
  removeFileInput(index: number): void {
    this.fileInputs.splice(index, 1);
    this.modalTask.uploadFields.splice(index, 1);
  }

  showsuccestaskcreateFunc() {
    this.showsuccestaskcreate = true;
    setTimeout(() => {
      this.showsuccestaskcreate = false;
    }, 2000);
  }

  /**
   * Load published form templates for form task linking
   */
  loadPublishedForms(): void {
    this.loadingForms = true;

    const organizationId = SessionHelper.getChoosenOrg();
    if (!organizationId) {
      console.warn('No organization ID available for loading forms');
      this.loadingForms = false;
      return;
    }

    // Check if forms are already loaded in datastore
    const cachedForms = this.datastore.getPublishedForms();

    if (cachedForms && cachedForms.length > 0) {
      console.log('[ProjectStage] Using cached forms from datastore:', cachedForms.length);
      this.publishedForms = cachedForms;
      this.hasPublishedForms = this.publishedForms.length > 0;
      this.loadingForms = false;
      return;
    }

    // Load from API and cache in datastore
    this.datastore.loadPublishedForms()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (forms) => {
          this.publishedForms = forms;
          this.hasPublishedForms = this.publishedForms.length > 0;
          this.loadingForms = false;
        },
        error: (error) => {
          console.error('Error loading published forms:', error);
          this.publishedForms = [];
          this.hasPublishedForms = false;
          this.loadingForms = false;
        }
      });
  }

  /**
   * Generate a composite key for form template (id_vVersion)
   */
  getFormKey(form: FormTemplate): string {
    return `${form.id}_v${form.version}`;
  }

  /**
   * Handle form template selection
   */
  onFormSelected(): void {
    // ngModelChange ensures the model is already updated
    if (this.modalTask.formTemplateId) {
      // Parse composite key (format: id_vVersion)
      const [baseId, versionPart] = this.modalTask.formTemplateId.split('_v');
      const version = parseInt(versionPart);

      const selectedForm = this.publishedForms.find(f => f.id === baseId && f.version === version);
      if (selectedForm) {
        this.modalTask.formTemplateName = selectedForm.name;
        this.modalTask.formTemplateVersion = selectedForm.version;
      }
    } else {
      this.modalTask.formTemplateName = undefined;
      this.modalTask.formTemplateVersion = undefined;
    }
  }

  /**
   * Create form link after task creation (called after successful task save)
   */
  createFormLink(taskId: string): void {
    if (this.modalTask.tasktype === 'form' && this.modalTask.formTemplateId) {
      const organizationId = SessionHelper.getChoosenOrg();

      // Extract base ID from composite key (format: id_vVersion)
      const baseId = this.modalTask.formTemplateId.includes('_v')
        ? this.modalTask.formTemplateId.split('_v')[0]
        : this.modalTask.formTemplateId;

      const linkRequest = {
        templateId: baseId,
        templateVersion: this.modalTask.formTemplateVersion,
        templateName: this.modalTask.formTemplateName
      };

      this.formService.linkFormToTask(
        organizationId,
        taskId,
        linkRequest
      ).pipe(untilDestroyed(this)).subscribe({
        next: () => {
          console.log('Form template linked successfully');
        },
        error: (error) => {
          console.error('Error linking form template:', error);
        }
      });
    }
  }
}
